import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill,faWallet } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { msgAccessPromt } from "../../constant/constant";
import { adpaypeee, msgPromtsuccess,loaderActionSlice } from "../../features/userSlice";
import { useT } from "../../i18n";
const AddFUnAuto = () => {
  
const {Info}=useSelector((state)=>state.users);
const [money,setMoney]=useState('');
const [isdisabled,setisdisabled]=useState(false);

const dispatch=useDispatch();
const { t } = useT();
const handlePayment = async() => {
  if (parseInt(money)<parseInt(Info?.MIN_DEPOSIT)) {
         dispatch(msgPromtsuccess({msg:t('Minimum deposit limit is {amount}.',{amount:Info?.MIN_DEPOSIT}),error:true}));
         return;
       }
   setisdisabled(true);
   // const payeeAddress = Info?.UPI_ADMIN;
   // const payeeName = Info?.UPI_NAME || '';
   // const amount = money; // Replace with dynamic value
   // const currency = "INR";
   const transactionId = `TXN${Date.now()}`; // Generate unique transaction ID
   // const transactionNote = `Payment for Order${transactionId}`;
   // const redirectUrl = `https://matkafun.org/payment-status?transaction_id=${transactionId}`;

   var form_data_new = new FormData();

   form_data_new.append('USER_ID',Info?.phone_number);
   form_data_new.append('TRANS_ID',transactionId);
   form_data_new.append('AMOUNT',money);

  
   // const upiUrl = encodeURI(`upi://pay?pa=${payeeAddress}&pn=${payeeName}&am=${amount}&cu=${currency}&tn=${transactionNote}&url=${redirectUrl}`);

   // console.log(upiUrl);

     // Redirect to UPI apps
     try{
       dispatch(loaderActionSlice(true));
     const data = await dispatch(adpaypeee(form_data_new)).unwrap(); // Unwrap to get the resolved value
             if(data?.status && data?.status!=='FAILURE'){
                     window.location.href = data.result.payment_url;
              }else if(data?.status==='FAILURE'){
               msgAccessPromt({dispatch,error:true,msg:data?.msg});
              }
     }catch(error){
       msgAccessPromt({dispatch,error:true,msg:'Something went wrong. Please try again.'});
     }
     dispatch(loaderActionSlice(false));
   setisdisabled(false);
 };

return (
        <div className="af-screen">
            <div className="af-hero">
                <img src='home/images/add_money.png' alt={t("Add Money")} />
            </div>
            <div className="af-balance">
                <span className="af-balance-icon"><FontAwesomeIcon icon={faWallet} /></span>
                <div>
                    <strong>₹{(Number(Info.wallet)!==0 || Info.wallet===null)?Info.wallet+'.00':Info.wallet}</strong>
                    <span>{t('Total Wallet Balance')}</span>
                </div>
            </div>
            <label className="af-label" htmlFor="add-fund-amount">{t("Add Fund")}</label>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faMoneyBill} /></i>
                <input id="add-fund-amount" className="input_lable_deep" type="number" inputMode="numeric" value={money} onChange={(e)=>setMoney(e.target.value)} placeholder={t("Enter points")} />
            </div>
            <button disabled={isdisabled} onClick={handlePayment} className="continue-button">{t("Pay")}</button>
        </div>
    );
};

export default AddFUnAuto;
